import React, {useRef, useState} from "react";
import {safeHTML} from "../../utils/safeHTML";
import classNames from "classnames";
import OriginalPostsItem from "./OriginalPostsItem";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import Icon from "../baseComponents/gui/icon/Icon";
import {settings} from "../../constants/carousel-settings";
import AppearSensor from "../baseComponents/helpers/appearSensor/AppearSensor";
import dynamic from "next/dynamic";
const Carousel = dynamic(() => import('../baseComponents/gui/carousel/Carousel'), {ssr: false});
import styles from "./OriginalPosts.module.scss";



const OriginalPosts = React.forwardRef(
  function OriginalPosts({list, mod,className}, ref) {
    const newList = list; // TEST LIST!!!!
    const [status, setStatus] = useState("start");
    const title = "От авторов";
    const paginationRef  = useRef(null);
    const prevRef  = useRef(null);
    const nextRef  = useRef(null);

    return (
      <section className={classNames(styles.originalPosts, className,{
        [styles[`originalPosts_${mod}`]]: mod,
        [styles[`originalPosts_${status}`]]:status,
      })} ref={ref}>
        <AppearSensor>
          {({hasBeenVisible}) =>
            <div className={classNames(styles.originalPosts__content,{
              "_show":hasBeenVisible
            })}>
              <h2 className={styles.originalPosts__title}>{safeHTML(title)}</h2>

              <Carousel
                item={OriginalPostsItem}
                itemsData={newList}
                settings={{
                  ...settings.originalSetting,
                  navigation: {
                    prevEl: prevRef.current,
                    nextEl: nextRef.current
                  },
                  pagination: {
                    el: paginationRef.current,
                    type: 'bullets',
                    clickable: true,
                  },
                  onReachEnd:()=>{
                    setStatus("end")
                  },
                  onReachBeginning:()=>{
                    setStatus("start")
                  },
                  onSlideChange:({isBeginning, isEnd})=>{
                    if (!isBeginning && !isEnd){
                      setStatus("")
                    }
                  }
                }
                }
              />
              <div className={styles.originalPosts__pagination} ref={paginationRef}/>
              <div className={styles.originalPosts__navigation}>
                <Button className={classNames(
                  buttonStyles.button_white,
                  buttonStyles.button_icon,
                  styles.originalPosts__navButton,styles.originalPosts__navButton_prev
                )}
                        aria-label={"назад"}
                        title={"назад"}
                        ref={prevRef}
                >
                  <Icon name={"prev"} width={56} height={56} />
                </Button>
                <Button className={classNames(
                  buttonStyles.button_white,
                  buttonStyles.button_icon,
                  styles.originalPosts__navButton,styles.originalPosts__navButton_next
                )}
                        aria-label={"вперед"}
                        title={"вперед"}
                        ref={nextRef}
                >
                  <Icon name={"next"} width={56} height={56}/>
                </Button>
              </div>
            </div>
          }
        </AppearSensor>
      </section>
    );
  });
export default OriginalPosts;
OriginalPosts.propTypes = {};

